import React from 'react';
import { TrackedLink } from 'components/common/TrackedLink';

export default function FormAddedFlashMessage({
  matterUrl,
  matterName,
  matterFormUrl,
}) {
  return (
    <div>
      <b>Success!</b> Form added to{' '}
      <TrackedLink to={matterUrl}>{matterName}</TrackedLink>.
      {matterFormUrl && (
        <>
          {' '}
          <TrackedLink to={matterFormUrl}>Edit it</TrackedLink> as a part of
          this matter now.
        </>
      )}
    </div>
  );
}
